"use strict";
function identity(x) {
    return x;
}
exports.identity = identity;
//# sourceMappingURL=identity.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/util/identity.js
// module id = 00YY
// module chunks = 12